import { Row } from "@components/Flex";
import { ProgressBar } from "@components/ProgressBar";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { useGoalsContext, useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { convertCentsToDollar, formatCurrency } from "@utils";
import { useStyles } from "./styles";
import { GoalProgressBarProps } from "./types";

export const GoalProgressBar = ({ style }: GoalProgressBarProps) => {
  const { theme } = useTheme();
  const styles = useStyles();

  const { goal, targetYear } = useGoalsContext();

  if (
    !goal ||
    goal.targetAmountInCents == null ||
    goal.currentAmountInCents == null ||
    !goal.endDate
  ) {
    return null;
  }

  const progress = goal.currentAmountInCents / goal.targetAmountInCents;

  const goalTargetAmount = formatCurrency(convertCentsToDollar(goal.targetAmountInCents));

  return (
    <div style={{ ...styles.container, ...style }}>
      <Row>
        <Body style={styles.left}>{i18n.t(Translations.GoalProgressBarTitle)}</Body>
        <Body style={styles.right}>{goalTargetAmount}</Body>
      </Row>
      <Spacing size={SpacingSizes.XS} />

      <ProgressBar
        progress={progress}
        backgroundColor={theme.goal.progress.bar.background}
        color={theme.goal.progress.bar.default}
      />
      <Spacing size={SpacingSizes.XS} />
      <Row>
        <Body style={styles.left}>{i18n.t(Translations.GoalProgressBarSubtitle)}</Body>
        <Body style={styles.right}>{targetYear}</Body>
      </Row>
    </div>
  );
};
